import { useTranslation } from "react-i18next";
import { DotsIcon, EditIcon } from "@/shared/icons";
import { AppDropdown } from "@/shared/Components/AppDropdown";
import type { FC } from "react";
import type { MenuProps } from "antd";

interface Props {
  onEdit?: () => void;
  className?: string;
  rootClassName?: string;
}

export const MobileActionsMenu: FC<Props> = ({ onEdit, className, rootClassName }) => {
  const { t } = useTranslation();

  const menuItems: MenuProps["items"] = [
    { label: t("common.edit"), key: 1, icon: <EditIcon />, onClick: onEdit },
  ];
  return (
    <AppDropdown menu={{ items: menuItems }} className={className} rootClassName={rootClassName}>
      <DotsIcon />
    </AppDropdown>
  );
};
